import { Router } from "@frui.ts/screens";
import { Modules } from "config";
import type Distributor from "entities/distributor";
import DistributorRepository from "repositories/distributorRepository";
import ConfirmationService from "services/confirmationService";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import SecurityService from "services/securityService";
import type DistributorType from "entities/distributorType";
import type DistributorStatus from "entities/distributorStatus";
import ListViewModel from "../../../listViewModel";
import DistributorCreateViewModel from "./distributorCreateViewModel";
import DistributorDetailViewModel from "./distributorDetailViewModel";

const navigationName = "distributor-management";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [DistributorCreateViewModel, DistributorDetailViewModel],
})
export default class DistributorManagementViewModel extends ListViewModel<
  Distributor,
  DistributorDetailViewModel,
  DistributorCreateViewModel
> {
  readonly modelName = "distributor";

  constructor(
    protected createViewModelFactory: () => DistributorCreateViewModel,
    protected detailViewModelFactory: ReturnType<typeof DistributorDetailViewModel.Factory>,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected confirmationService: ConfirmationService,
    protected securityService: SecurityService,
    protected eventBus: EventBus,
    protected repository: DistributorRepository
  ) {
    super();
    this.navigationName = navigationName;
  }

  get name() {
    return this.translate("name");
  }

  protected fetchData() {
    return this.repository.getAllActive();
  }

  translateTypeEnum(value: DistributorType) {
    return this.localizationService.translateEnum("distributorType", value);
  }

  translateStatusEnum(value: DistributorStatus) {
    return this.localizationService.translateEnum("distributorStatus", value);
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.timeCharges, `distributorManagement.${code}`, size);
  }
}
